// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1TPwU","block":"style_block__3zIAN","agreement":"style_agreement__2tbyQ","covid":"style_covid__KxffM","covidBooleanSelect":"style_covidBooleanSelect__19CaO"};